// GENERATED FILE - DO NOT MODIFY

export enum EventTypeDto {
    Work = "Work",
    OffHourAvailability = "OffHourAvailability",
    Away = "Away",
}